import { z } from 'zod';
import { IsoTimestampSchema } from './shared.js';
/**
 * T-TASKAUTO-3 — task-automation idempotency ledger entity. One row per fire;
 * `idempotencyKey` is unique (the dedup guarantee). See evaluator.idempotencyKey.
 */
export const TaskAutomationFireSchema = z.object({
    id: z.string(),
    ruleId: z.string(),
    entityKind: z.enum(['account', 'deal', 'submission']),
    entityId: z.string(),
    idempotencyKey: z.string(),
    taskId: z.string().nullable(),
    firedAt: IsoTimestampSchema,
});
//# sourceMappingURL=task-automation-fire.js.map